module.exports = __webpack_public_path__ + "img/english-study-lestening-active.124a3a3f.svg";